import React from 'react'

const Handbag = () => {
  return (
    <div>Handbag</div>
  )
}

export default Handbag